import script from "./LeavesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeavesSection.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__